import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RejectedHeartRunnerComponent from '../components/rejectedHeartRunnerComponent';
import {getUserRejectedList, deleteRejectedUser,approveFirstResponderUser,getAllRegionSettings } from '../actions/rejectedHeartRunnerListAction';

class RejectedHeartRunnerContainer extends Component {
    constructor(props){
        super(props)
    }
    componentDidMount(){
       // this.props.actions.getUserRejectedList();
        this.props.actions.getAllRegionSettings();
    }
    getUserList = (data) =>{
                    this.props.actions.getUserRejectedList(data,
                        this.props.dispatch
                    )
                }
    deleteUser = (itemId,Region) => {
        this.props.actions.deleteRejectedUser(
            itemId,Region,
            this.props.dispatch
        )
    }
    onApproveUser = (data,Region) =>{
        this.props.actions.approveFirstResponderUser(
            data,Region,
            this.props.dispatch
        )
    }
     getRegionData = () => {
                     this.props.actions.getAllRegionSettings(this.props.dispatch);
                  } 
    render() {
        return(
                  <div className="agile-grids">
                                        <div className="grids">
                                            <div className="container">
                                                <div className="row">
                                                  <RejectedHeartRunnerComponent
                    rejectedHeartRunnerList = {this.props.rejectedHeartRunnerList}
                    onDelete = {this.deleteUser}
                    onApprove = {this.onApproveUser}
                     getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
                >
                </RejectedHeartRunnerComponent>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
           
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getUserRejectedList,
            deleteRejectedUser,
            approveFirstResponderUser,
             getAllRegionSettings,
        }, dispatch)
    };
};

function mapStateToProps({rejectedHeartRunnerReducer}) {
    console.log(rejectedHeartRunnerReducer)
    return {
        rejectedHeartRunnerList: {
            isLoading: false,
            rejectedHeartRunnerList: rejectedHeartRunnerReducer.rejectedHeartRunnerList,
            errorCode : rejectedHeartRunnerReducer.errorCode,
            statusCode : rejectedHeartRunnerReducer.statusCode,
            message : rejectedHeartRunnerReducer.message,
            regionList : rejectedHeartRunnerReducer.regionList,
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RejectedHeartRunnerContainer))